import FlextLogo from "public/Apel.svg";

export const HEADER = {
  logo: {
    href: "/",
    title: <FlextLogo />,
    alt: "Flext Logo",
  },
  nav: [
    {
      href: "/",
      title: "Home",
      alt: "Home Page",
      desktop: false,
    },
    {
      href: "/team",
      title: "Team",
      alt: "Meet Our Team",
      desktop: true,
    },
    {
      href: "/events",
      title: "Events",
      alt: "Explore Our Events",
      desktop: true,
    },
    {
      href: "/faq",
      title: "Faq",
      alt: "Frequently Asked Question",
      desktop: true,
    },
    {
      href: "/Registration/sign_in",
      title: "Education",
      alt: "Education part",
      desktop: true,
    },
    {
      href: "/contact",
      title: "Contact",
      alt: "Contact Us",
      desktop: true,
    },
    {
      href: "/forms",
      title: "Forms",
      alt: "Join The compitions",
      desktop: true,
    }
  ],
  profileNav: [],
};
